<template>
  <div>
    <create-task v-if="site.id" :pbn="site"></create-task>
    <div class="row m-b-lg m-t-lg wrapper" v-if="site">
      <div class="col-md-12">
        <!-- <div class="dropdown pull-right" v-if="user.admin">
          <button class="btn btn-xs btn-primary" id="pbnActions" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false"><i class="fa fa-wrench"></i></button>
          <ul class="dropdown-menu" aria-labelledby="pbnActions">
            <li>
              <a class="dropdown-item" data-toggle="modal" data-target="#create-task"><i class="fa fa-tasks"></i> Create Task</a>
              <a class="dropdown-item" style="color: red"  @click="deletePbn"><i class="fa fa-remove"></i> Delete</a>
            </li>
          </ul>
        </div> -->
        <button v-if="user.admin" class="btn btn-xs btn-danger pull-right m-r-xs" v-tooltip="'Delete'" @click="deletePbn"><i class="fa fa-trash"></i></button>
        <button v-if="user.admin" class="btn btn-xs btn-success pull-right m-r-xs" v-tooltip="'Add a task'" data-toggle="modal" data-target="#add-task"><i class="fa fa-plus"></i></button>
        <button class="btn btn-xs btn-primary pull-right m-r-xs" @click="reloadPbn"><i class="fas fa-sync-alt" title="Reload PBN Data"></i></button>
        <h3 v-if="site.deleted" style="color: red"><a :href="'https://' + site.domain" target="_blank" class="red" style="text-decoration: line-through">{{ site.domain }}</a> [DELETED]</h3>
        <h3 v-else>
          <a :href="'https://' + site.domain" target="_blank">{{ site.domain }}</a>
        </h3>
        <h4 v-if="site.wpData">
          <small v-if="site.wpData.title">Title: <b>{{ site.wpData.title }}</b></small>
          <small v-if="site.wpData.theme">Theme: <b>{{ site.wpData.theme }}</b></small>
        </h4>
        <h6 v-if="user.username === 'rok'"><a @click="copyToClipboard(site.id)">{{ site.id }} <i class="fa fa-copy"></i></a></h6>
        <a :href="'https://app.ahrefs.com/site-explorer/overview/v2/subdomains/live?target=' + site.domain" target="_blank" title="Ahrefs"><i class="fab fa-angular"></i></a>
        <i class="fa fa-lock" v-if="!site.hasLogins && (!site.integrations || !site.integrations.hosting || site.integrations.hosting.hostingType !== 'CUSTOM_HOST')" style="color: red;" title="Production login missing"></i>
        <i class="fas fa-parking text-navy" title="Parked" v-if="site.parked"></i>
      </div>
      <div class="col-lg-6 col-md-12">
        <div class="row">
          <div class="col-md-4">
            <table class="table small m-b-xs">
              <tbody>
              <tr>
                <td>Client</td>
                <td>
                  <e-txt
                    :locked="!user.admin"
                    type="select"
                    :text="site.client ? site.client.name : '/'"
                    :selected-value="site.client ? site.client.id : null"
                    @input="updateProperty($event, 'client'); updateProperty(null, 'group')"
                    :options="filters.clients"
                    select-value="id"
                    select-label="name"
                    close-on-save="true"
                  ></e-txt>
                </td>
              </tr>
              <tr>
                <td>Group</td>
                <td>
                  <e-txt
                    :locked="!user.admin"
                    type="select"
                    :text="site.group ? site.group.name : '/'"
                    :selected-value="site.group ? site.group.id : null"
                    @input="updateProperty($event, 'group')"
                    :options="user.admin &&  filters.groupsByClient && site.client ? filters.groupsByClient[site.client.id] : filters.groups"
                    select-value="id"
                    select-label="name"
                    close-on-save="true"
                  ></e-txt>
                </td>
              </tr>
              <tr v-if="filters.orders">
                <td>Order</td>
                <td>
                  <e-txt
                    :locked="!user.admin"
                    type="select"
                    :text="site.order ? site.order.name : '/'"
                    :router-link="site.order && (user.admin || user.roles.length) ? '/pbn/order/' + site.order.id : null"
                    :selected-value="site.order ? site.order.id : null"
                    @input="updateProperty($event, 'order')"
                    :options="filters.orders.concat({name: '/', id: null})"
                    select-value="id"
                    select-label="name"
                    close-on-save="true"
                  ></e-txt>
                </td>
              </tr>
              <tr>
                <td>Tags</td>
                <td>
                  <v-select name="" multiple taggable push-tags :value="site.tags" @input="updateTags" ref="tags" v-if="user.admin"></v-select>
                  <span v-else v-for="tag in site.tags" :key="tag" class="btn btn-xs btn-primary">{{ tag }}</span>
                </td>
              </tr>
              <tr>
                <td>Category</td>
                <td>
                  <e-txt
                    :locked="!user.admin"
                    type="select"
                    :text="site.category ? site.category : '/'"
                    @input="updateProperty($event, 'category')"
                    :options="filters.categories"
                    close-on-save="true"
                  ></e-txt>
                </td>
              </tr>
              <tr>
                <td>Hold:</td>
                <td>
                  <e-txt
                    type="select"
                    :options="yesNoQ"
                    :allow-null="true"
                    select-value="index"
                    select-label="label"
                    :selected-value="site.domainHold"
                    @input="updateProperty($event, 'domainHold')"
                    :close-on-save="true"
                  >
                    <span slot="yes" class="green">Yes</span>
                    <span slot="no" class="red">No</span>
                    <span slot="null" class="orange">?</span>
                  </e-txt>
                </td>
              </tr>
              <tr v-if="!site.accessible">
                <td colspan="2" class="red">
                  Not accessible
                  <a @click="updateProperty(true, 'accessible')"><i class="fa fa-trash pull-right green" v-tooltip="'Access OK'"></i></a>
                </td>
              </tr>
              <tr>
                <td>SSO:</td>
                <td>
                  <i class="fa fa-check green" v-if="site.sso"></i>
                  <i class="fa fa-remove red" v-else-if="site.sso === false"></i>
                  <i class="fa fa-question yellow" v-else></i>
                </td>
              </tr>
              </tbody>
            </table>
          </div>
          <div class="col-md-4">
            <table class="table small m-b-xs">
              <tbody>
              <tr>
                <td>Type</td>
                <td>
                  <e-txt
                    type="select"
                    :text="site.type"
                    :locked="!user.admin"
                    @input="updateProperty($event, 'type')"
                    :options="types"
                    close-on-save="true"
                    select-label="label"
                    select-value="index"
                    :selected-value="site.type"
                  ></e-txt>
                </td>
              </tr>
              <tr v-if="site.type === 'redirect'">
                <td>Target:</td>
                <td>
                  <e-txt
                    type="text"
                    :close-on-save="true"
                    :text="site.pbnOptions.targetDomain"
                    @input="updateProperty($event, 'pbnOptions.targetDomain')"
                  ></e-txt>
                </td>
              </tr>
              <tr>
                <td>Status</td>
                <td>
                  <e-txt
                    :locked="!user.admin"
                    type="select"
                    :text="site.status"
                    @input="updateProperty($event, 'status')"
                    :options="statuses"
                    select-value="id"
                    select-label="label"
                    close-on-save="true"
                    :selected-value="site.status"
                  ></e-txt>
                </td>
              </tr>
              <tr v-if="site.type !== 'redirect'">
                <td>Language:</td>
                <td>{{ site.language ? site.language.join(',') : '/' }}</td>
              </tr>
              <tr>
                <td>Domain expiry:</td>
                <td>
                  <span v-if="site.expires">
                    <e-txt
                      type="date"
                      :text="site.expires.date"
                      :locked="!user.admin"
                      close-on-save="true"
                      show-save-button="true"
                      @input="updateProperty($event, 'expires')"
                    ></e-txt> (in {{ site.expiresIn }} days)
                  </span>
                  <span v-else>
                    ?
                  </span>
                </td>
              </tr>
              <tr>
                <td>Expired:</td>
                <td>
                  <e-txt
                    type="select"
                    options="YesNo"
                    :select-value="site.expired"
                    :selected-value="site.expired"
                    @input="updateProperty($event, 'expired')"
                  >
                    <span slot="yes" class="red">Yes</span>
                    <span slot="no" class="green">No</span>
                  </e-txt>
                </td>
              </tr>
              <tr v-if="site.integrations && site.integrations.registrar">
                <td>Auto renew:</td>
                <td>
                  <i class="fa fa-check green" v-if="site.integrations.registrar.autoRenew" v-tooltip="'Auto renew on'"></i>
                  <i class="fa fa-ban gray" v-else v-tooltip="'Manual renewal'"></i>
                  <i class="fa fa-calendar-times red" v-tooltip="'Let Expire'" v-if="site.integrations.registrar.extraData && site.integrations.registrar.extraData.letExpire"></i>
                </td>
              </tr>
              <tr v-if="site.customData && site.customData.doServer && site.customData.doServer.length < 30">
                <td>Server:</td>
                <td>
                  {{ site.customData.doServer }}
                </td>
              </tr>
              <tr>
                <td>SW:</td>
                <td>{{ site.software }}</td>
              </tr>
              </tbody>
            </table>
          </div>
          <div class="col-md-4">
            <table class="table small m-b-xs">
              <tbody>
              <tr v-if="site && site.content && site.type !== 'redirect'">
                <td>Posts:</td>
                <td><b>{{ site.content.posts || '?' }}</b></td>
              </tr>
              <tr v-if="site.content && site.type !== 'redirect'">
                <td>Pages:</td>
                <td><b>{{ site.content.pages || '?' }}</b></td>
              </tr>
              <tr v-if="site.type !== 'redirect'">
                <td>Post update:</td>
                <td>{{ site.content && site.content.lastUpdate ? $moment(site.content.lastUpdate.date ? site.content.lastUpdate.date : site.content.lastUpdate).format('DD.MM.YYYY') : '?' }}</td>
              </tr>
              <tr v-if="site.type !== 'redirect'">
                <td>Content import:</td>
                <td>
                  <span v-if="site.imports && site.imports.content">{{ site.imports.content | aTime('from') }}</span>
                  <a v-if="user.admin" class="pull-right"><i class="fas fa-refresh" title="Request import" @click="requestContentImport"></i></a>
                </td>
              </tr>
              <tr>
                <td>Indexed</td>
                <td>
                  <i class="fa fa-check green" v-if="site.indexed"></i>
                  <i class="fa fa-question orange" v-else-if="!site.imports || !site.imports.indexCheck"></i>
                  <i class="fa fa-remove red" v-else></i>
                  <span v-if="site.indexed && site.indexCount">{{ site.indexCount }}</span>
                </td>
              </tr>
              <tr>
                <td>Index check</td>
                <td>
                  <span v-if="site.imports && site.imports.indexCheck">
                    {{ site.imports.indexCheck | aTime('from') }}
                  </span>
                  <a class="pull-right" @click="refreshIndex" v-if="user.admin"><i class="fas fa-refresh"></i></a>
                </td>
              </tr>
              <tr>
                <td>Stats import:</td>
                <td>{{ site.imports && site.imports.stats ? $moment(site.imports.stats.date).format('DD.MM.YYYY') : '/' }}</td>
              </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
      <div class="col-lg-6 col-md-12">
        <div class="row">
          <div class="col-lg-12">
            <table class="table table-striped table-hover table-bordered">
              <thead>
              <tr>
                <th>Dns <a @click="runQa('v2/dns')" v-tooltip="'Run QA'"><i class="fa fa-refresh pull-right"></i></a></th>
                <th>Status <a @click="runQa('v2/status')" v-tooltip="'Run QA'"><i class="fa fa-refresh pull-right"></i></a></th>
                <th v-if="site.type !== 'redirect'">Content</th>
                <th>Index</th>
              </tr>
              </thead>
              <tbody>
              <tr>
                <td v-for="type in ['dns','status','content','index']" :key="'qa-' + type" v-if="site.qa && (type !== 'content' || site.type !== 'redirect')">
                  <i class="fa fa-check green" v-if="site.qa[type] && site.qa[type].success === true"></i>
                  <i class="fa fa-remove red" v-else-if="site.qa[type] && site.qa[type].success === false"></i>
                  <i class="fa fa-question gray" v-else></i>
                  <span v-if="site.qa[type]">
                    {{ site.qa[type].time | aTime('from') }}
                    <i class="fa fa-info pull-right green"
                       v-if="site.qa[type].check && site.qa[type].check.messages.length"
                       v-tooltip="site.qa[type].check.messages.join('<br>')"></i>
                    <i class="fa fa-info pull-right orange"
                       v-if="site.qa[type].check && site.qa[type].check.warnings.length"
                       v-tooltip="site.qa[type].check.warnings.join('<br>')"></i>
                    <i class="fa fa-warning pull-right red"
                       v-if="site.qa[type].check && site.qa[type].check.errors.length"
                       v-tooltip="site.qa[type].check.errors.join('<br>')"></i>
                  </span>
                </td>
              </tr>
              </tbody>
            </table>
          </div>
          <div class="col-lg-12">
            <table class="table table-striped table-bordered table-hover m-b-n">
              <thead>
              <tr>
                <th colspan="2">External Links</th>
                <th colspan="8" v-if="site">
                  <span v-if="user.admin">
                    <span v-if="site && site.linkProfile">
                      <span
                        v-for="tag in site.linkProfile.own" :key="'own-linktag-' + tag"
                        class="label label-primary m-r-sm"
                      >{{ tag }}</span>
                      <span v-for="tag in site.linkProfile.others" :key="'others-linktag-' + tag" class="label label-success m-r-sm"
                            v-if="site.linkProfile && site.linkProfile.others">{{ tag }}</span>
                      <span v-for="tag in site.linkProfile.anonymous" :key="'anon-linktag-' + tag" class="label label-info m-r-sm"
                            v-if="site.linkProfile && site.linkProfile.anonymous">{{ tag }}</span>
                      </span>
                    </span>
                  <span v-else>
                  <span
                    v-for="tag in site.linkProfile" :key="'own-linktag-' + tag"
                    class="label label-primary m-r-sm"
                  >{{ tag }}</span>
                  </span>
                </th>
              </tr>
              </thead>
              <tbody>
<!--              <tr>-->
<!--                <td colspan="10">-->
<!--                  <a v-for="link in site.linkDomains" :key="'linkdomain-' + link" class="m-r-sm"><i class="fa fa-external-link"></i> {{ link }}</a>-->
<!--                </td>-->
<!--              </tr>-->
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { mapGetters } from 'vuex'
import axios from 'axios'
import EditText from '../../../Helpers/Form/EditText'
import { Browser, String } from '../../../../mixins/helperMixin'
import { PBN_SET } from '../../../../store/mutation-types'
import Swal from 'sweetalert2'
import AddTaskModal from '../../TaskManager/Tasks/AddTaskModal.vue'

export default {
  data () {
    return {
      statuses: [
        {label: 'Unknown', id: 'unknown'},
        {label: 'Not built', id: 'not-built'},
        {label: 'Building', id: 'building'},
        {label: 'Built', id: 'built'},
        {label: 'Waiting Deploy', id: 'waiting-deploy'},
        {label: 'Waiting Deploy Client', id: 'waiting-deploy-client'},
        {label: 'Disabled', id: 'disabled'}
      ],
      siteTags: [],
      updateLock: true,
      siteClient: null,
      yesNoQ: [
        {label: 'Yes', index: true},
        {label: 'No', index: false},
        {label: 'Unknown', index: null}
      ]
    }
  },
  components: {
    eTxt: EditText,
    createTask: AddTaskModal
  },
  computed: {
    ...mapGetters({
      site: 'getPbn',
      filters: 'getFilters',
      user: 'getUser',
      types: 'getPbnTypes'
    })
  },
  mixins: [String, Browser],
  mounted () {
    this.reloadPbn(false)
    if (!this.filters.clients) {
      this.$store.dispatch('loadFilters')
    }
    this.updateLock = true
    this.siteTags = this.site.tags || []
    this.updateLock = false
    if (!this.types.length) {
      this.$store.dispatch('fetchPbnTypes')
    }
  },
  methods: {
    reloadPbn (msg = true) {
      axios.get('/pbn/site/' + this.$route.params.domain)
        .then(r => {
          this.$store.commit(PBN_SET, r.data)
          if (msg) {
            this.$toastr.success('Pbn data reloaded')
          }
        })
        .catch(e => {
        })
    },
    updateTags () {
      axios.patch('/pbn/site/' + this.site.punyDomain, {
        tags: this.$refs.tags.valueAsArray
      }).then(r => {
        this.$toastr.success('PBN Tags updated', 'Disco Disco')
      }).catch(e => {
        this.$toastr.error(e, 'Tag Update Failed')
      })
    },
    updateClient () {
      axios.patch('/pbn/site/' + this.site.punyDomain, {
        client: this.$refs.client.value
      })
        .then(r => {
          this.$toastr.success('Client updated', 'Alright!')
        }).catch(e => {
          this.$toastr.error(e, 'Client Update Failed')
        })
    },
    updateGroup () {
      axios.patch('/pbn/site/' + this.site.punyDomain, {
        group: this.$refs.group.value
      })
        .then(r => {
          this.$toastr.success('Group updated', 'Alright!')
        }).catch(e => {
          this.$toastr.error(e, 'Group Update Failed')
        })
    },
    updateProperty (val, prop) {
      let data = {}
      data[prop] = val

      if (val === 'null') {
        val = null
      }

      axios.patch('/pbn/site/' + this.site.punyDomain, data)
        .then(r => {
          this.$toastr.success(this.ucFirst(prop) + ' updated', 'Alright!')
          this.$store.commit(PBN_SET, r.data.pbn)
        }).catch(e => {
          this.$toastr.error(e, this.ucFirst(prop) + ' Update Failed')
        })
    },
    updateOrder () {
      axios.patch('/pbn/site/' + this.site.punyDomain, {
        order: this.$refs.order.value
      })
        .then(r => {
          this.$toastr.success('Order updated', 'Alright!')
        }).catch(e => {
          this.$toastr.error(e, 'Order Update Failed')
        })
    },
    requestContentImport () {
      axios.post('/pbn/site/' + this.site.punyDomain + '/content/request')
        .then(r => {
          this.$toastr.success('Check back in a minute or two', 'Content Import Requested')
          this.$store.commit(PBN_SET, r.data.pbn)
        })
        .catch(e => {
          this.$toastr.error(e, 'Request Failed')
        })
    },
    deletePbn () {
      Swal.fire({
        title: 'Are you sure you want to delete this pbn?',
        text: 'If you change your mind a certain dev may be rather pissed off when asked to restore it for you...',
        icon: 'warning',
        showCancelButton: true,
        cancelButtonText: 'No no, all good, close this thing',
        confirmButtonText: 'Ye, away with this useless thing'
      }).then(r => {
        if (r.isConfirmed) {
          axios.delete('/pbn/site/' + this.site.punyDomain).then(r => {
            this.$toastr.success('As you wish', this.site.domain + ' has been deleted')
            this.$router.push('/pbn')
          }).catch(e => {
            this.$toastr.error(e, 'There seems to be an issue')
          })
        }
      })
    },
    runQa (check) {
      axios.post(`/pbn/site/${this.site.punyDomain}/qa/run`, {
        checks: [
          check
        ]
      }).then(r => {
        this.$toastr.success('Added QA check to the queue')
      }).catch(e => {})
    },
    refreshIndex () {
      axios.post(`/pbn/site/${this.site.punyDomain}/index/refresh`)
        .then(r => {
          this.$toastr.success('Index update requested')
        })
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/Pages/Pbn/Single/Header.vue